import {
	brand,
	functional,
	global,
	universal
} from './colour-tokens'

const { littlewoods, very } = brand;

const colours = {
	very: {
		...very,
	},
	littlewoods: {
		...littlewoods,
	},
	global: {
		...global,
	},
	universal: {
		...universal,
	},
	functional: {
		...functional,
	},
	base: {
		black: global.black,
		white: global.white,
	},
	greys: {
		grey10: global.grey1000,
		grey9: global.grey900,
		grey8: global.grey800,
		grey7: global.grey700,
		grey6: global.grey600,
		grey5: global.grey500,
		grey4: global.grey400,
		grey3: global.grey300,
		grey2: global.grey200,
		grey1: global.grey100,
	},
};

export default colours;
